import { render, staticRenderFns } from "./current-monitor.vue?vue&type=template&id=34fac36f"
import script from "./current-monitor.vue?vue&type=script&lang=ts"
export * from "./current-monitor.vue?vue&type=script&lang=ts"
import style0 from "./current-monitor.vue?vue&type=style&index=0&id=34fac36f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports